<template>
    <!-- <div class="title content-section">测试</div> -->
    <div class="aden-title">
        <div class="text-center" v-for="title in titles" :key="title">{{  title  }}</div>
    </div>
</template>

<script>
export default {
    name: "AdenTitle",
    props: {
        titles: []
    },
};
</script>

<style lang="scss" scoped>
.aden-title {
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  line-height: 1.5;
  padding-bottom: 23px;
  position: relative;
}
.aden-title::after {
  content: "";
  transform: translateX(-50%);
  border: 3px solid #C6A14A;
  position: absolute;
  left: 50%;
  bottom: 3px;
  width: 146px;
}
</style>
